var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.element)?_c('div',[_c('DateDropdownHint',{attrs:{"value":_vm.entryItem.dateValue,"placeholder":_vm.element.name},on:{"input":_vm.changed}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }